const storage = window.localStorage;

export function storeLanguage(data) {
  window.localStorage.setItem("internalLanguage", JSON.stringify(data));
}

export function readLanguage() {
  return JSON.parse(window.localStorage.getItem("internalLanguage"));
}

export function store(key, data) {
  if (!storage || !key) return;
  storage.setItem(key, JSON.stringify(data));
}

export function read(key) {
  if (!storage || !key) return;
  const item = storage.getItem(key);
  if (!item) return;
  return JSON.parse(item);
}

export function remove(key) {
  if (!storage || !key) return;
  storage.removeItem(key);
}
